import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Calendar, Phone, Mail } from 'lucide-react';
import { openCalendlyPopup } from '@/utils/calendly';
const AppointmentBooking = () => {
  const handleCalendlyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    openCalendlyPopup();
  };
  return <section className="py-20 bg-gradient-subtle" id="afspraak" aria-labelledby="appointment-heading">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 id="appointment-heading" className="text-4xl font-bold text-secondary mb-4">
              Plan een afspraak
            </h2>
            <p className="text-xl text-muted-foreground">
              Maak een afspraak voor persoonlijk verzekeringsadvies op maat
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div className="space-y-8">
              <Card className="p-6">
                <h3 className="text-2xl font-bold text-secondary mb-6">Contactgegevens</h3>
                
                <div className="space-y-4">
                  <div className="flex items-center space-x-3">
                    <Phone className="w-5 h-5 text-primary" />
                    <a href="tel:0782200021" className="hover:text-primary transition-colors">078 - 220 00 21</a>
                  </div>
                  
                  <div className="flex items-center space-x-3">
                    <Mail className="w-5 h-5 text-primary" />
                    <span>info@compleetverzekerd.nl</span>
                  </div>
                  
                  <div className="flex items-start space-x-3">
                    <Calendar className="w-5 h-5 text-primary mt-0.5" />
                    <div>
                      <div className="font-semibold">Openingstijden</div>
                      <div className="text-muted-foreground">
                        Ma-Vr: 09:00 - 17:30
                      </div>
                    </div>
                  </div>
                </div>
              </Card>

              <Card className="p-6 bg-primary text-primary-foreground">
                <h3 className="text-xl font-bold mb-4">Waarom een afspraak maken?</h3>
                
                <ul className="space-y-3">
                  <li className="flex items-start space-x-2">
                    <span className="w-2 h-2 bg-accent rounded-full mt-2"></span>
                    <span>Persoonlijk advies op maat</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="w-2 h-2 bg-accent rounded-full mt-2"></span>
                    <span>Gratis vergelijking van verzekeringen</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="w-2 h-2 bg-accent rounded-full mt-2"></span>
                    <span>Besparing tot wel 40% mogelijk</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="w-2 h-2 bg-accent rounded-full mt-2"></span>
                    <span>Directe hulp bij vragen</span>
                  </li>
                </ul>
              </Card>
            </div>

            {/* Calendly Link Widget */}
            <Card className="p-6 text-center">
              <h3 className="text-2xl font-bold text-secondary mb-6">Plan direct je afspraak</h3>
              
              <div className="space-y-6">
                <p className="text-muted-foreground text-sm">Je kunt een afspraak inplannen via de website of even bellen met een van onze medewerkers. Je krijgt geen keuze menu maar gewoon contact met een adviseur of assistent. De afspraak kan plaatsvinden bij ons op kantoor of online via een videogesprek.<br />
                Een gesprek duurt meestal 15 tot 60 minuten, afhankelijk van jouw situatie. Er worden geen kosten in rekening gebracht voor een adviesgesprek. In veel gevallen is een afspraak niet eens nodig en kunnen we je direct telefonisch al verder helpen.</p>
                
                <Button size="lg" onClick={handleCalendlyClick}>
                  <Calendar className="mr-2 w-5 h-5" />
                  Plan een afspraak
                </Button>
                
                <div className="bg-muted p-4 rounded-lg">
                  <p className="text-sm text-muted-foreground">
                    ✨ Er opent een popup waar je direct een geschikt tijdslot kunt kiezen
                  </p>
                </div>

                <p className="font-bold text-xl">Of bel ons</p>
                
                <Button size="lg" asChild>
                  <a href="tel:0782200021">
                    <Phone className="mr-2 h-5 w-5" />
                    078 - 220 00 21
                  </a>
                </Button>
                
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>;
};
export default AppointmentBooking;